import useMedia from 'use-media';
import { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import { Collapse } from '@mui/material';
import Arrow from '../assets/icons/icon_dropdown.png';

export function FooterInfo() {
  const tablet = useMedia({ maxWidth: 768 });
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => setIsOpen(false), []);
 
  return (
    <div className="footer-info">
      {tablet ? (
        <>
          <Button
            className="unset txt-n"
            onClick={() => {
              const next = !isOpen;
              setIsOpen(next);
            }}
          >
            <span style={{color: '#000',fontSize: '12px'}}>사업자정보</span>
         
            <img
              className="toggle-btn"
              style={
                isOpen
                  ?
                  { transform: 'rotate(180deg)' }
                  :
                  { transform: 'rotate(0)' }
              }
              src={Arrow } alt="toggle-box" />
          
          </Button>


          <Collapse in={isOpen}>
            <div className="footer-info-inner">
              <p>
                (주)동아사이언스 <span>|</span> 대표 : 장경애 <span>|</span>{' '}
                개인정보관리책임자 : 최수정 <span>|</span> 청소년보호책임자 : 박무성{' '}
                <span>|</span>{' '}
                (03737) 서울시 서대문구 충정로 29, 10층{' '}
              </p>
              <p>
                문의 : 02-6749-2002 <span>|</span> 팩스 : 02-3148-0789
              </p>
              <p>
                사업자등록번호 : 101-81-62201(
                <a
                  href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1018162201&apv_perm_no="
                  target="_blank"
                  style={{color: '#757575'}}
                >
                  사업자정보확인
                </a>
                ) <span>|</span> 통신판매업신고번호 : 2024-서울서대문-0682호
              </p>
            </div>
            <p className="footer-copy">
              Copyright © Donga Science. All rights reserved.
            </p>
          </Collapse>
        </>
      ) : (
        <>
          <div className="footer-info-inner">
            <p>
              (주)동아사이언스 <span>|</span> 대표 : 장경애 <span>|</span>{' '}
              개인정보관리책임자 : 최수정 <span>|</span> 청소년보호책임자 : 박무성{' '}
              <span>|</span>{' '}
              (03737) 서울시 서대문구 충정로 29, 10층{' '}
            </p>
            <p>
              문의 : 02-6749-2002 <span>|</span> 팩스 : 02-3148-0789
            </p>
            <p>
              사업자등록번호 : 101-81-62201(
              <a
                href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1018162201&apv_perm_no="
                target="_blank"
              >
                사업자정보확인
              </a>
              ) <span>|</span> 통신판매업신고번호 : 2024-서울서대문-0682호
            </p>
          </div>
          <p className="footer-copy">
            Copyright © Donga Science. All rights reserved.
          </p>
        </>
      )}
    </div>
  );
}

export default FooterInfo;